import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
var categoryList = []
Vue.use(Vuex)
const state = {
  category: []
}
const getters = {
  getNCategoryStoreData: (state, getters) => searchParameters => {
    categoryList = []
    // console.log(searchParameters)
    for (let i = 0; i < searchParameters; i++) {
      categoryList.push(getters.getCategoryStoreData[i])
    }
    // alert(JSON.stringify(categoryList))
    return categoryList
  },
  getCategoryStoreData: function (state) {
    return state.category
  }
}
const actions = {
  fetchSearchCategory (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('o/getcategorymaster'
        )
        .then(response => {
          context.commit('setCategoryStoreData', response.data)
          resolve()
        })
        .catch(e => {
          console.log('err:', e)
          reject(e)
        })
    })
  }
}
const mutations = {
  setCategoryStoreData (state, data) {
    if (data === null) {
      state.category = []
    } else {
      state.category = data
    }
  },
  clearCategoryStoreData (state) {
    state.category = []
  }
}
export default {
  state,
  actions,
  getters,
  mutations,
  plugins: [createPersistedState({ storage: window.localStorage })]
}



// WEBPACK FOOTER //
// ./src/store/modules/filter.js